/* Icônes « Lisse » : un geste par icône au survol de la souris, apparition une fois pour les icônes de contenu. */
(() => {
  if (window.__bgcomIcLisse) return; window.__bgcomIcLisse = 1;
  const RM = matchMedia('(prefers-reduced-motion: reduce)'), FINE = matchMedia('(hover: hover) and (pointer: fine)');
  const play = s => { if (!s || RM.matches || s.dataset.play) return; s.removeAttribute('data-in'); s.dataset.play = s.dataset.k; setTimeout(() => s.removeAttribute('data-play'), 650); };
  document.addEventListener('pointerover', e => {
    if (!FINE.matches || !e.target.closest) return;
    const h = e.target.closest('a,button,summary,label,[data-ic-host]');
    if (!h || h.contains(e.relatedTarget)) return;
    play(h.querySelector('.bgc-ic'));
  }, { passive: true });
  if (RM.matches || !('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const io = new IntersectionObserver(es => {
    let i = 0;
    for (const en of es) {
      const s = en.target;
      if (!seen.has(s)) { seen.add(s); if (en.isIntersecting) { io.unobserve(s); continue; } s.setAttribute('data-pre', ''); continue; }
      if (!en.isIntersecting) continue;
      io.unobserve(s); s.style.setProperty('--d', (i++ * 45) + 'ms'); s.removeAttribute('data-pre'); s.setAttribute('data-in', '');
      setTimeout(() => s.removeAttribute('data-in'), 1000 + i * 45);
    }
  }, { threshold: 0.4 });
  const watch = () => document.querySelectorAll('.bgc-ic.is-ct:not([data-ic-w])').forEach(s => { s.setAttribute('data-ic-w', ''); io.observe(s); });
  watch(); document.addEventListener('shopify:section:load', watch);
})();
